import { Component, Input } from '@angular/core';

@Component({
  selector: 'rapicredit-skeleton',
  template: `<div class="skeleton" [ngStyle]="{ height: height, width: width }"></div>`,
  styleUrls: ['./rapicredit-skeleton.component.css'],
})
export class RapicreditSkeletonComponent {
  @Input() public width: string = '100px';
  @Input() public height: string = '38px';
}
